module.exports = __webpack_public_path__ + "static/media/Nisheethbandaru.accb94ec.png";